import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
    Button,
    Grid
} from '@material-ui/core';

const styles = () => ({
    displayFlex: {
        display: 'flex',
    },
    verticalSpace: {
        margin: '25px 0px 20px 30px',
    },
    clearButtonSpace: {
        margin: '25px 50px 20px 0px',
    },
});

const ResetButton = (props) => {
    const {
        classes,
        setRecordId,
        setCreationStartDate,
        setCreationEndDate,
        setKeyword,
        setData
    } = props;

    const clearUserDatas = () => {
        setRecordId('');
        setCreationStartDate('');
        setCreationEndDate('');
        setKeyword('');
        setData([]);
    };

    return (
        <React.Fragment>
            <Grid>
                <div>
                    <div className={classes.displayFlex + ' ' + classes.verticalSpace}>
                        <Button size="large" className={classes.clearButtonSpace} variant="contained" onClick={() => clearUserDatas()}>リセット</Button>
                    </div>
                </div>
            </Grid>
        </React.Fragment>
    );
};

ResetButton.propTypes = {
    setRecordId: PropTypes.func.isRequired,
    setCreationStartDate: PropTypes.func.isRequired,
    setCreationEndDate: PropTypes.func.isRequired,
    setKeyword: PropTypes.func.isRequired,
    setData: PropTypes.func.isRequired,
};

export default withStyles(styles)(ResetButton);